import { render } from "./DotPiece.vue?vue&type=template&id=1a19491a&scoped=true"
import script from "./DotPiece.vue?vue&type=script&lang=js"
export * from "./DotPiece.vue?vue&type=script&lang=js"

import "./DotPiece.vue?vue&type=style&index=0&id=1a19491a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a19491a"

export default script